module.exports = __webpack_public_path__ + "img/edge_hiver_stade_alpin.57fc45eb.svg";